import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import { getProjectIdOrKey } from '@jira/router-resources__utils/src/getProjectKeyId.tsx';
import type { ProjectContext } from './ProjectContext.types.tsx';

export const projectContextResource: RouteResource<ProjectContext | null> =
	createResource<ProjectContext | null>({
		type: 'PROJECT_CONTEXT',
		getKey: (matchedRoute) => getProjectIdOrKey(matchedRoute.match, matchedRoute.query),
		getDataLoader: () =>
			import(
				/* webpackChunkName: "async-resource-project-context", jiraSpaEntry: "async-resource-project-context" */ './getData.tsx'
			),
		maxAge: 30 * 60 * 1000,
		isCritical: true,
	});
export const projectContextResourceWithCache: RouteResource<ProjectContext | null> =
	projectContextResource;
